export default "__VITE_ASSET__DdFpMW5V__"